import {styled} from "@mui/material/styles";
import {cssVarColors} from "../../../../Constants";
import {
	mobileThreshold,
	portfolioWidth,
	smallThreshold
} from "../../../../Constants/layoutValues";

// export const FeatureSectionWrapper = styled('div')`
// 	width: 100%;
// 	height: 500px;
// 	background-image: url('https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/backgroundVideo2.mp4');
// 	background-size: cover;
// 	background-repeat: no-repeat;
// 	background-position: left top;
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
//
// 	@media (max-width: 768px) {
// 		background-position: left top;
// 		background-size: cover;
// 	}
// `;

export const FeatureSectionWrapper = styled('div')`
	position: relative;
	width: 100%;
	height: 500px;
	overflow: hidden;
	background-image: url('https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/parliamentHill2.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: right bottom;
`

export const BackgroundVideo: React.FC<React.VideoHTMLAttributes<HTMLVideoElement>> = (props) => (
	<video
		{...props}
		style={{
			position: 'absolute',
			top: 0,
			left: 0,
			height: '100%',
			objectFit: 'contain',
			objectPosition: 'left top',
			pointerEvents: 'none',
			zIndex: 1000
		}}
	/>
);

export const ImagePlaceholder = styled('img')`
	max-height: 100%;
	position: absolute
`;

export const InternalWrapper = styled('div')`
	width: 100%;
	display: flex;
	flex-direction: row;
	max-height: 100%;
	align-items: flex-end;
	justify-content: flex-end;
	height: 100%;
	z-index: 1001; // 🔼 bump above video
	position: relative;
	@media (max-width: ${mobileThreshold}px)
	{
		padding-left: 1rem;
	}
`;

export const PlaceholderRight = styled('div')`
	display: flex;
	max-height: 100%;
	flex: 1;
`;

export const ImageWrapper = styled('div')`
	max-width: 100%;
	height: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-end;
	flex: 1;
	@media (max-width: ${mobileThreshold}px)
	{
		height: 60%;
	};
`;

export const Image = styled('img')`
	height: 100%;
	width: auto;
	object-fit: contain;
`;


export const RightContent = styled('div')`
	display: flex;
	height: 100%;
	padding-right: 2rem;
	padding-bottom: 2rem;
	align-items: flex-end;
	justify-content: center;
`;
